const radioGroupStyles = {
  radioItem: {
    '&:not(:last-child)': {
      marginRight: 10
    }
  }
};

export default radioGroupStyles;
